module.exports = __webpack_public_path__ + "static/media/play_store.7bf5d76e.png";